import { IconNames } from '@blueprintjs/icons';
import { Icon } from '@strata/react-status-icons';

import {
    type ClaimFrequencyType,
    ClaimFrequencyTypeIconDisplayTextMap,
    ClaimFrequencyTypes,
} from 'services/MedicalBillingConstants';

const ClaimFrequencyTypeIconMap = {
    [ClaimFrequencyTypes.ORIGINAL]: undefined,
    [ClaimFrequencyTypes.RESUBMIT]: IconNames.CHANGES,
    [ClaimFrequencyTypes.VOID]: IconNames.BAN_CIRCLE,
} as const;

interface ClaimFrequencyTypeIconProps {
    claimFrequencyType: ClaimFrequencyType | undefined;
    iconOnly?: boolean;
}

export const ClaimFrequencyTypeIcon = ({
    claimFrequencyType,
    iconOnly = false,
}: ClaimFrequencyTypeIconProps) => {
    if (!claimFrequencyType) {
        return null;
    }

    const icon = ClaimFrequencyTypeIconMap[claimFrequencyType];
    const displayText = ClaimFrequencyTypeIconDisplayTextMap[claimFrequencyType];

    return (
        <div className="flex__gap--small" style={{ alignItems: 'center' }}>
            {icon && (
                <Icon
                    icon={icon}
                    title={displayText}
                    tooltipContent={iconOnly ? displayText : undefined}
                />
            )}
            {!iconOnly && <span>{displayText}</span>}
        </div>
    );
};
